export const removeWhiteSpaceAndSpecialCharacters = (text?: string | null): string => {
    if (text === undefined || text === null) return 'not-unique';
    return text.replace(/[^a-zA-Z0-9]/g, '');
};

export const firstCharToUpperCase = (text: string): string => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
};
